export default __webpack_public_path__ + "static/media/Directions2021_2023.d75d26f2.pdf";